export const variantsColorScheme = {
  // https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-color-scheme
  colorScheme: {
    light: 'not (prefers-color-scheme: dark)',
    dark: '(prefers-color-scheme: dark)',
  },
};
